const getDomicileStatus = (status) => {
    const deliveryStatus = [
        {
            order: 1,
            status: 'order_paid',
            label: 'Compra procesada',
        },
        {
            order: 2,
            status: 'confirmed',
            label: 'Compra preparada',
        },
        {
            order: 3,
            status: 'picked_up',
            label: 'Compra retirada por courier',
        },
        {
            order: 4,
            status: 'in_transit',
            label: 'Compra en tránsito a destino',
        },
        {
            order: 5,
            status: 'delivered',
            label: 'Compra entregada',
        },
    ];
    return deliveryStatus.filter((d) => d.status === status)[0];
};

const getPickupStatus = (status) => {
    const deliveryStatus = [
        {
            order: 1,
            status: 'Pendiente',
            label: 'Pendiente',
        },
        {
            order: 2,
            status: 'Disponible en tienda',
            label: 'Listo para retiro',
        },
        {
            order: 3,
            status: 'Entregado',
            label: 'Entregado',
        },
    ];
    return deliveryStatus.filter((d) => d.status === status)[0];
};

document.addEventListener('DOMContentLoaded', async () => {
    const input = document.querySelector('input[name="order"]');
    const button = document.querySelector('button.enviar_orden');
    const order_information = document.querySelector('#order_information');
    const recaptcha_error = document.querySelector('.recaptcha-error');

    async function sendOrder(value) {
        try {
            if (value.length === 0) throw new Error('');

            order_information.innerHTML = `
                <div class="order_title">
                    <h3>Cargando...</h3>
                </div>
            `;

            const res = await fetch(
                `https://sq37gsa2c2.execute-api.us-east-1.amazonaws.com/prod/tracking?trackingCode=${value}`,
                { method: 'GET' }
            );
            const resJson = await res.json();

            if (res.status === 200) {
                const { shippingTitle, trackingData } = resJson;
                const { status, promised_date } = trackingData;
                if (shippingTitle.includes('Despacho')) {
                    const { order, label } = getDomicileStatus(
                        status === 'not_exist' ? 'order_paid' : status
                    );

                    order_information.innerHTML = '';
                    order_information.innerHTML = `
                    <div class="order_title">
                        <h3>Nº de compra: ${value}</h3>
						<p>
							${
                                promised_date && status !== 'not_exist'
                                    ? `Fecha estimada de entrega: ${promised_date}<br/>`
                                    : ''
                            }
  						</p>
                    </div>
                    <div class="order_status">
                        <b>Estado de la orden:</b> ${label}
                    </div>
                    <ul id="progress">

                        <li><div class="node ${
                            order >= 1 ? 'active_color' : 'grey'
                        } ${
                        order === 1 ? 'activated' : ''
                    }"></div><p>Compra procesada</p></li>

                        <li><div class="divider ${
                            order >= 2 ? 'active_color' : 'grey'
                        }"></div></li>
                        <li><div class="node ${
                            order >= 2 ? 'active_color' : 'grey'
                        } ${
                        order === 2 ? 'activated' : ''
                    }"></div><p>Compra preparada</p></li>

                        <li><div class="divider ${
                            order >= 3 ? 'active_color' : 'grey'
                        }"></div></li>
                        <li><div class="node ${
                            order >= 3 ? 'active_color' : 'grey'
                        } ${
                        order === 3 ? 'activated' : ''
                    }"></div><p>Compra retirada por courier</p></li>

                        <li><div class="divider ${
                            order >= 4 ? 'active_color' : 'grey'
                        }"></div></li>
                        <li><div class="node ${
                            order >= 4 ? 'active_color' : 'grey'
                        } ${
                        order === 4 ? 'activated' : ''
                    }"></div><p>Compra en tránsito a destino</p></li>

                        <li><div class="divider ${
                            order >= 5 ? 'active_color' : 'grey'
                        }"></div></li>
                        <li><div class="node ${
                            order >= 5 ? 'active_color' : 'grey'
                        } ${
                        order === 5 ? 'activated' : ''
                    }"></div><p>Compra entregada</p></li>

                    </ul>
                `;
                }
                if (shippingTitle.includes('Retiro')) {
                    const { order, label } = getPickupStatus(
                        status === 'not_exist' ? 'Pendiente' : status
                    );
                    order_information.innerHTML = '';
                    order_information.innerHTML = `
                    <div class="order_title">
                        <h3>Nº de compra: ${value}</h3>
						<p>
							<b>${shippingTitle}</b>
  						</p>
                          ${
                              status === 'Pendiente'
                                  ? `
                            <p>
                                Recuerda que podrás retirar tu pedido 48hrs <br/>
                                después de haber concretado la compra <br/>
                                <a href='/pages/retiro-en-tienda'>
                                    <u>Más información aquí.</u>
                                </a>
                            </p>
                        `
                                  : ''
                          }
                    </div>
                    <div class="order_status">
                        <b>Estado de la orden:</b> ${status}
                    </div>

                    <ul id="progress">

                        <li><div class="node ${
                            order >= 1 ? 'active_color' : 'grey'
                        } ${order === 1 ? 'activated' : ''}"></div>
                    <p>
                    Pendiente
                    
                    </p>
                    
                    </li>

                        <li><div class="divider ${
                            order >= 2 ? 'active_color' : 'grey'
                        }"></div></li>
                        <li><div class="node ${
                            order >= 2 ? 'active_color' : 'grey'
                        } ${
                        order === 2 ? 'activated' : ''
                    }"></div><p>Listo para retiro</p></li>

                        <li><div class="divider ${
                            order >= 3 ? 'active_color' : 'grey'
                        }"></div></li>
                        <li><div class="node ${
                            order >= 3 ? 'active_color' : 'grey'
                        } ${
                        order === 3 ? 'activated' : ''
                    }"></div><p>Entregada</p></li>
                    </ul>
                `;
                }
            } else {
                const { message } = resJson;
                if (message === 'La orden no existe.') {
                    throw 'NotExist';
                }
                throw '';
            }
        } catch (error) {
            let message =
                'En mantenimiento, Por favor, inténtelo de nuevo más tarde';

            if (error === 'NotExist') {
                message = 'La orden consultada no existe';
            }

            if (error === 'Failure') {
                message =
                    'La orden indicada aun no tiene seguimiento o aun no se termina de procesar';
            }

            order_information.innerHTML = `
                <div class="order_title">
                    <h3>${message}</h3>
                    <small>
                        Recuerda que si tu compra es con <b>Retiro en tienda</b>, podras retirarla 48hrs después de haber concretado la compra,
                        <a href="/pages/retiro-en-tienda" style="text-decoration:underline;"> Más información aquí. </a>
                    </small>
                </div>
            `;
        }
    }

    button.addEventListener('click', async (e) => {
        e.preventDefault();

        if (input.value.length > 2) {
            const response = grecaptcha.getResponse();

            if (response.length > 0) {
                recaptcha_error.innerText = '';
                grecaptcha.reset();
                await sendOrder(input.value);
            } else {
                recaptcha_error.innerText =
                    'Debes verificar que no eres un robot.';
            }
        }
    });

    function triggerEvent(element, event) {
        const clickEvent = new Event(event);
        element.dispatchEvent(clickEvent);
    }

    function getParameterByName(name, url) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
    }

    const trackingId = getParameterByName('order_name', window.location.search);
    if (trackingId != null) {
        document.getElementById('order').value = trackingId.replace('AN', '');
        triggerEvent(document.getElementById('order-submit'), 'click');
    }
});
